module.exports = {
      id: "notification-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#notification",
      toString: function () {
        return this.url;
      }
    }